<template>
  <v-autocomplete
    hide-details="auto"
    :items="SaleTypes"
    :loading="loading"
    v-model="filterDatas.saleType"
    item-text="name"
    item-value="id"
    label="Sale Type"
    clearable
    outlined
    dense
    @change="emitInput(filterDatas.saleType)"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    SaleTypes: [
      {
        id: 'cash',
        name: 'Cash',
      },
      {
        id: 'credit',
        name: 'Credit',
      },
    ],

    loading: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_SALETYPE_FILTER', data);
      this.$emit('input', this.filterDatas.saleType);
    },
  },

  created() {
    this.$emit('input', this.filterDatas.saleType);
  },
};
</script>
